export default "__VITE_ASSET__BVH5lhim__"